import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function present<T>(obj: T): obj is Exclude<T, null | undefined | '' | false> {
  if (typeof obj === "string") {
    return /\S/.test(obj)
  }
  if (typeof obj === 'number') {
    // "0" is considered present
    return true
  }

  return !!obj
}
